import { css } from "@emotion/react";

import { LockBlack } from "@livechat/design-system-icons";
import { Icon } from "@livechat/design-system-react-components";

import { ISideNavigationItem } from "interfaces/sideNavigationItem";
import { ReportsRoutes } from "routes/reports/constants";

import { ReportType } from "./report-type";

export const NavigationItems = (hasReportExportOption = false, hasAuditLog = false): ISideNavigationItem[] => [
  {
    id: ReportType.Last7days,
    name: "Last 7 days",
    path: ReportsRoutes.Last7Days,
  },

  {
    id: ReportType.NewTickets,
    name: "New tickets",
    path: ReportsRoutes.NewTickets,
  },
  {
    id: ReportType.TicketRatings,
    name: "Ticket satisfaction",
    path: ReportsRoutes.TicketSatisfaction,
  },
  {
    id: ReportType.TicketFirstResponseTime,
    name: "First response time",
    path: ReportsRoutes.FirstResponseTime,
  },
  {
    id: ReportType.TicketResolutionTime,
    name: "Resolution time",
    path: ReportsRoutes.TicketResolutionTime,
  },
  {
    id: ReportType.HandlingTimeByStatus,
    name: "Handling time by status",
    path: ReportsRoutes.HandlingTimeByStatus,
  },
  {
    id: ReportType.SolvedAndClosed,
    name: "Solved and closed",
    path: ReportsRoutes.SolvedAndClosed,
  },
  {
    id: "generate-report",
    name: "Generate report",
    exportRoute: true,
    path: ReportsRoutes.GenerateReport,
    customBadge: !hasReportExportOption ? <Icon css={css({ position: "absolute", right: 0 })} source={LockBlack} /> : null,
  },
  {
    id: "audit-log",
    name: "Audit log",
    path: ReportsRoutes.AuditLog,
    customBadge: !hasAuditLog ? <Icon css={css({ position: "absolute", right: 0 })} source={LockBlack} /> : null,
  },
];
